import { render, staticRenderFns } from "./MicrophoneLevel.vue?vue&type=template&id=2b54dfef&scoped=true&"
import script from "./MicrophoneLevel.vue?vue&type=script&lang=js&"
export * from "./MicrophoneLevel.vue?vue&type=script&lang=js&"
import style0 from "./MicrophoneLevel.vue?vue&type=style&index=0&id=2b54dfef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b54dfef",
  null
  
)

export default component.exports